import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getMenu} from '../actions/menu';
import { Link } from 'react-router-dom';
import menuArrow from '../images/arrow-up.svg';
import i18n from 'i18next';


class Menu extends Component {
    static propTypes = {
        dataMenu: PropTypes.object,
        isShowLoader: PropTypes.bool,
        menuKeys: PropTypes.array,
        currentCategory: PropTypes.string
    }

    /**
     * Mounting component and get all data
     *
     * @param nextProps
     */
    componentDidMount(nextProps) {
        this.props.getMenu(i18n.language);
    }

    /**
     * ucfirst
     *
     */
    ucfirst = (str) =>{
        var f = str.charAt(0).toUpperCase();
        return f + str.substr(1, str.length-1);
    }


    /**
     * Renders nested list with unlimited nested levels
     *
     *
     * @param child
     * @param nested
     * @returns {*}
     */
    renderNestedList = ( child, nested = false ) => {
        var language = i18n.language;
        var methodName = 'categoryName'+ this.ucfirst(language);

        if ( nested === true ){
                return (
                    <div className="sub-dropdown" uk-dropdown="pos: right-top">
                        <ul className="uk-nav uk-dropdown-nav uk-padding-remove">
                        {
                            Object.keys(child).map((keyChild) => {
                                const isCategoryLink = Object.keys(child[keyChild].child).length > 0?"/list":"";
                                return  <li key={child[keyChild].data.id}>
                                        <Link className={"uk-link-reset uk-margin-small-left"}
                                            to={`/products/${i18n.language + '/' + child[keyChild].data.alias + isCategoryLink}`}>
                                            {child[keyChild].data[methodName]}
                                        </Link>
                                        {Object.keys(child[keyChild].child).length > 0?this.renderNestedList(child[keyChild].child, true):''}
                                    </li>
                                }
                            )
                        }
                        </ul>
                    </div>)
            }else{
                if ( Object.keys(child.child).length === 0 ){
                    return (<li className='parent-link'  key={child.data.id}>
                        <Link className='uk-flex uk-flex-middle uk-flex-between'  to={`/products/${i18n.language+'/'+child.data.alias}`}>
                           <span className='parent-link__name'>{child.data[methodName]}</span>
                        </Link>
                        </li>)
                }
                if ( Object.keys(child.child).length > 0 ){
                   
                    return (
                        <li className='parent-link uk-parent'  key={child.data.id}>
                            <Link  className={this.props.currentCategory===child.data.alias?"menu-nav__parent uk-flex-middle uk-flex-between":"active uk-flex uk-flex-middle uk-flex-between"} to={`/products/${i18n.language+'/'+child.data.alias+'/list'}`}>
                                <span className='parent-link__name'>{child.data[methodName]}</span>
                            </Link>
                            <div className={"uk-dropdown uk-dropdown-right-top"} uk-dropdown="pos: right-top">
                                <ul className="uk-nav uk-dropdown-nav uk-padding-remove">
                                    {

                                        Object.keys(child.child).map(key => {

                                       
                                            const isCategoryLink = Object.keys(child.child[key].child).length > 0?"/list":"";
                                            return <li key={key}>
                                                <Link
                                                    className={this.props.currentCategory === child.data.alias ? "menu-nav__parent uk-flex-middle uk-flex-between" : "active"}

                                                    to={`/products/${i18n.language + '/' + child.child[key].data.alias + isCategoryLink}`}>
                                                    <b>{child.child[key].data[methodName]}</b>
                                                    {Object.keys(child.child[key].child).length > 0?<img className="submenu-arrow" src={menuArrow} uk-svg="" />:''}
                                                </Link>
                                                {Object.keys(child.child[key].child).length > 0?this.renderNestedList(child.child[key].child, true):''}
                                            </li>
                                        }
                                        )
                                    }
                                </ul>
                            </div>

                        </li>
                    )
                 }
            }
    }

    /**
     * Renders menu
     *
     * @returns {*}
     */
    render() {
        
        return(<>
        <ul className={`header-catalog-list uk-list ${this.props.catalogState?'uk-hidden':''}`}  >
            {this.props.isShowLoader === false ?
                
                     this.props.menuKeys.map( (key, inc) =>
                        <div key={`menukeys_${key}`}>
                        { this.renderNestedList(this.props.dataMenu[key]) }
                        </div>
                            
                        
                    )
                
            :(<div>Loading......</div>)
            }
            </ul>
        </>);
    }
}

const mapStateToProps = (store) => {
    const {dataMenu,isShowLoader} = store.menu;
   
    return {
        menuKeys: Object.keys(dataMenu),
        dataMenu:dataMenu,
        isShowLoader:isShowLoader
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getMenu: (lang) => {
           dispatch(getMenu(lang))
        }
    }
}

export default connect(mapStateToProps ,mapDispatchToProps)(Menu)
